"use client";
import { useEffect, useRef, useState } from "react";
import { useTranslations } from 'next-intl';
import { gsap } from "gsap";

const steps = [
    {
        step: "how_work_step_1",
        title: "how_work_step_1_title",
        description: "how_work_step_1_desc",
    },
    {
        step: "how_work_step_2",
        title: "how_work_step_2_title",
        description: "how_work_step_2_desc",
    },
    {
        step: "how_work_step_3",
        title: "how_work_step_3_title",
        description: "how_work_step_3_desc",
    },
    {
        step: "how_work_step_4",
        title: "how_work_step_4_title",
        description: "how_work_step_4_desc",
    },
    {
        step: "how_work_step_5",
        title: "how_work_step_5_title",
        description: "how_work_step_5_desc",
    },
    {
        step: "how_work_step_6",
        title: "how_work_step_6_title",
        description: "how_work_step_6_desc",
    },
    {
        step: "how_work_step_7",
        title: "how_work_step_7_title",
        description: "how_work_step_7_desc",
    },
    {
        step: "how_work_step_8",
        title: "how_work_step_8_title",
        description: "how_work_step_8_desc",
    },
    {
        step: "how_work_step_9",
        title: "how_work_step_9_title",
        description: "how_work_step_9_desc",
    },
    {
        step: "how_work_step_10",
        title: "how_work_step_10_title",
        description: "how_work_step_10_desc",
    },
    {
        step: "how_work_step_11",
        title: "how_work_step_11_title",
        description: "how_work_step_11_desc",
    },
    {
        step: "how_work_step_12",
        title: "how_work_step_12_title",
        description: "how_work_step_12_desc",
    }
];

export default function HowWorks() {
    const t = useTranslations('Home');
    const title = t('how_work');
    const words = title.split(" ");
    const headlineRef = useRef<HTMLHeadingElement>(null);
    const subRef = useRef<HTMLParagraphElement>(null);

    const StepItem = ({ key, step, t }: any) => {
        const [isOpen, setIsOpen] = useState(false);
        return (
            <div className="border-b border-gray-100 pb-0 mb-1 last:border-0 group" onClick={() => setIsOpen(!isOpen)}>
                <span className="text-sm text-violet-600 font-medium">{t(step.step)}</span>

                <div
                    className="flex justify-between items-center cursor-pointer mt-4"
                >
                    <h3 className="text-xl font-semibold group-hover:opacity-100">{t(step.title)}</h3>
                </div>
                <div
                    className={`transition-all duration-300 ease-in-out overflow-hidden ${isOpen
                            ? "max-h-96 opacity-100 mt-2"
                            : "max-h-0 opacity-0"
                        }`} // Always visible on desktop: md:max-h-none md:opacity-100 md:block
                >
                    <p className="text-gray-600 max-w-[500px]">
                        {t(step.description)}
                    </p>
                </div>
            </div>
        );
    };

    useEffect(() => {
        const tl = gsap.timeline();
        tl.from(headlineRef.current, {
            opacity: 0,
            x: -50,
            duration: 1,
            ease: "power3.out",
        })
            .from(subRef.current, {
                opacity: 0,
                x: 50,
                duration: 1,
            }, "-=0.5");
    }, []);

    return (
        <section className="py-4 md:py-20 px-5 md:px-20 mt-10 md:mt-20">
            {/* Section Title */}
            <div className="mx-auto text-start mb-16 flex flex-col md:flex-row justify-between items-start">
                <div className="flex flex-col gap-8 md:sticky md:top-20">
                    <h2 className=" text-4xl md:text-6xl font-bold mb-4 max-w-[500px] capitalize" ref={headlineRef}>
                        <span className="color-primary">{words[0]}</span>{" "}
                        {words.slice(1).join(" ")}
                    </h2>
                    <p className=" text-xl max-w-[550px]" ref={subRef}>
                        {t('how_work_subtitle1')}
                    </p>
                    <p className=" text-xl max-w-[550px]" ref={subRef}>
                        {t('how_work_subtitle2')}
                    </p>
                </div>
                <div className="space-y-8 mx-auto">
                    <div className="flex mt-8 md:mt-0">
                        <div className="relative hidden w-10 flex flex-col items-center">
                            <div className="absolute top-0 bottom-0 w-[1px] bg-gray-700"></div>
                            {steps.map((_, idx) => (
                                <div key={idx} className="relative z-10 mb-34 last:mb-0">
                                    <div className="w-5 h-5 rounded-full bg-violet-400 shadow-md"></div>
                                </div>
                            ))}
                        </div>
                        {/* Right - Texts */}
                        <div className="flex-1 space-y-16 pl-4 md:pl-10">
                            {steps.map((step, idx) => (
                                <StepItem key={idx} step={step} t={t} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
